<div>
    <app-audi-text variant="order4" className="audi-type-normal" text="This site is currently offline or under maintenance, please try again later.">
    </app-audi-text>

    <br /><br />
    <app-audi-button text="Home" (click)="onHome()"></app-audi-button>
</div>